export const STATE_FRAME_COLLECTION = 'frameCollection';

export const ACTION_FOCUS_SECTION_FRAME = '@FrameCollection/ACTION_FOCUS_SECTION_FRAME';
export const ACTION_UPDATE_CONTENT_HEIGHT = '@FrameCollection/ACTION_UPDATE_CONTENT_HEIGHT';

export const URL_TYPE_IFRAME = 'iframe';
export const URL_TYPE_THIRD_PARTY_IFRAME = 'third_party_iframe';
export const URL_TYPE_NEW_TAB = 'new_tab';
export const URL_TYPE_SAME_TAB = 'same_tab';
export const URL_TYPE_NEW_WINDOW = 'new_window';
export const URL_TYPE_DEBUG_INFO = 'debug_info';
export const URL_TYPE_IFRAME_LOCATION_CHANGE = 'iframe_location_change';
export const URL_TYPE_THIRD_PARTY_IFRAME_LOCATION_CHANGE = 'third_party_iframe_location_change';
